export default __webpack_public_path__ + "static/media/not-found.be6a1fe6.svg";